import React from "react";
import { Carousel, CarouselItem } from "react-bootstrap";

const GalleryCarousel = ({ gallery, activeImage, setActiveImage }) => {
  // console.log(activeImage);
  return (
    <Carousel
      data-bs-theme="dark"
      id="gallery-carousel"
      className="h-100"
      activeIndex={activeImage}
      onSelect={(selectedIndex) => setActiveImage(selectedIndex)}
    >
      {gallery.length > 0 &&
        gallery.map((img, i) => (
          <CarouselItem key={i} className="h-100">
            <div className="d-flex h-100">
              <img
                src={img.url}
                alt={`gallery-${img._id}`}
                className="img-fluid rounded-3 m-auto"
                style={{ maxHeight: "80vh", maxWidth: "90vw" }}
              />
            </div>
          </CarouselItem>
        ))}
    </Carousel>
  );
};

export default GalleryCarousel;
